import { render, staticRenderFns } from "./ValidityReport.vue?vue&type=template&id=4e31c528&scoped=true"
import script from "./ValidityReport.vue?vue&type=script&lang=js"
export * from "./ValidityReport.vue?vue&type=script&lang=js"
import style0 from "./ValidityReport.vue?vue&type=style&index=0&id=4e31c528&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e31c528",
  null
  
)

export default component.exports